import { Avatar } from '@unified-checkout/design-system';

import type { ICustomerInfo } from '@app/dashboard/types/innerLayout/reports/modals/share';

import styles from './customerInfo.module.scss';

export const CustomerInfo = ({ email, status }: ICustomerInfo) => {
  const shortName = email.charAt(0).toUpperCase();

  return (
    <div className={styles['customer-info']}>
      <Avatar 
        type="text"
        size="lg"
        shortName={shortName}
      />
      <div className={styles['customer-info__details']}>
        <p className={styles['customer-info__details__email']}>{email}</p>
        <p className={styles['customer-info__details__status']}>{status}</p>
      </div>
    </div>
  );
}; 